import React from "react";
import CsvUploader from '../extra/CsvUploader'
import { useLocation, useNavigate } from "react-router-dom";
import { downloadCSV } from "../../libs/Libs";
import { BsFileEarmarkArrowDown } from "react-icons/bs";
import { Box, Container } from "@mui/material";
export default function ClientCsv() {
  const fields = [
    { name: "business_entity", label: "Business Entity" },
    { name: "currency", label: "Currency" },
    { name: "business_name", label: "Business Name" },
    { name: "client_creation_date", label: "Client Creation Date" },

    { name: "gstin", label: "GSTIN" },
    { name: "type", label: "Type" },
    { name: "status", label: "Status" },
    { name: "gst_registration_date", label: "GST Registration Date" },

    { name: "place_of_supply", label: "Place of Supply" },
    { name: "address_1", label: "Address Line 1" },
    { name: "address_2", label: "Address Line 2" },

    { name: "country", label: "Country" },
    { name: "state", label: "State" },
    { name: "pincode", label: "Pincode" },

    { name: "cin_llp", label: "CIN/LLP" },
    { name: "tan", label: "TAN" },
    { name: "professional_tax", label: "Professional Tax" },
    { name: "esi_reg", label: "ESI Registration" },
    { name: "date_of_reg", label: "Date of Registration" },

    { name: "pan", label: "PAN" },
    { name: "udayam", label: "Udyam" },
    { name: "provident_fund", label: "Provident Fund" },
    { name: "lut_number", label: "LUT Number" }
  ];

  return (
    <>
      <Container maxWidth="false" sx={{ mt: 2, width: "100%" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, my: 2 }}>
          <button className="btn-primary pointer" onClick={() => downloadCSV(fields, 'client_import_template')}>
            <BsFileEarmarkArrowDown />  Download Template
          </button>
        </Box>
        <CsvUploader
          tableColumns={fields.map(f => f.name)}
          requiredFields={['business_entity', 'currency', 'business_name', 'client_creation_date']}
          onClose={() => { }} />
      </Container>
    </>
  )
}